











import { Component, Vue } from 'vue-property-decorator';

// Services
import Auth from '@/services/Auth';
import { getSettings } from '@/services/Settings';

@Component({
	name: 'AgentResources',
})
export default class AgentResources extends Vue {
	private readonly Auth = Auth;
	private active: boolean = false;

	private async created() {
		try {
			const getLiveChatStatus = await getSettings(['agentResourcesStatus']);
			this.active = getLiveChatStatus.data.find(
				s => s.setting_key === 'agentResourcesStatus',
			).active;
		} catch (e) {
			console.log(e);
		}
	}
}
